import React from 'react'

import styled from 'styled-components'

import DefaultAvatar from 'assets/images/early/a4-early-avatar.png'
import { EARLY_AVATAR_DEFAULT } from 'pages/early/test-support/test-ids'

type Props = {
  className?: string
  image?: {
    url: string
    personName: string
  }
}

const ImageContainer = styled.figure`
  margin: 40px auto 0;
  width: 107px;
  height: 107px;
  border-radius: 100%;
  overflow: hidden;
`

const Image = styled.img`
  object-fit: cover;
  width: 100%;
`

export const EarlyAvatar = ({ className, image }: Props) => (
  <ImageContainer className={className}>
    {image ? (
      <Image src={image.url} alt={`Photo of ${image.personName}.`} />
    ) : (
      <Image src={DefaultAvatar} alt="" data-testid={EARLY_AVATAR_DEFAULT} />
    )}
  </ImageContainer>
)
